import React from 'react';
import classNames from 'classnames';
import './SimpleToggle.scss';

const SimpleToggle = ({ disabled, label, onChange, value }) => {
  function handleClick() {
    onChange(!value);
  }

  return (
    <div
      className={classNames('SimpleToggle', {
        disabled,
      })}
    >
      {label ? (
        <div className="SimpleToggle-label text-interface-small">{label}</div>
      ) : null}
      <label className="SimpleToggle-switch">
        <input type="checkbox" onChange={handleClick} checked={value} />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

export default SimpleToggle;
